<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Deactivate Product] ' + product.product_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/products/view/${product.id}`">{{ product.product_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Deactivate</li>
                </ol>
            </nav>

            <h4 class="page-header">
                <span>Deactivate: {{ product.product_name }}</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <strong>Confirm Product Deactivate</strong>. This product will no longer be available for use in new contracts.<br/>

                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        Deactivate All Product Contracts?: <i class="fa fa-question-circle" title="If checked, AMOS365 will mark all contracts for this product inactive. This does NOT delete any data."></i>
                                    </div>
                                    <div class="col-md-8">
                                        <b-form-checkbox v-model="deactivate_all_contracts" :value="true" :unchecked-value="false" plain />
                                    </div>
                                </div>
                                <div class="row mt-4" v-if="deactivate_all_contracts">
                                    <div class="col-md-4">
                                        Set Inactive Contracts' Status (Optional): <i class="fa fa-question-circle" title="In addition to setting the deactive flag, use this field to set the actual contract status to your desired inactive status"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <b-form-select v-model="deactivate_status_id" :options="statusOptions" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-warning" v-on:click="deactivateProduct()" :disabled="deactivating">
                    <template v-if="deactivating"><i class="fas fa-spin fa-spinner"></i> Deactivating...</template>
                    <template v-else><i class="fas fa-power-off"></i> Deactivate</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deactivating: false,
                reassign_product_id: null,
                in_use: false,
                id: this.$route.params.id,
                product: {},
                errors: {},
                deactivate_all_contracts: false,
                deactivate_status_id: null,
            }
        },

        computed: {
            statusOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Contract Status --'}];

                //Main Loop
                for(var i = 0; i < this.statuses.length; i++)
                {
                    //Build the label
                    var label = this.statuses[i].contract_status_type + ' - ' + this.statuses[i].contract_status_name;

                    //Push
                    options.push({value: this.statuses[i].id, text: label});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getProduct(){
                //Send it
                this.$http.get('/products/deactivate/' + this.id)
                    .then(response => {
                        //Set the product
                        this.product = response.data.product;
                        this.statuses = response.data.statuses;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deactivateProduct(){
                //Helpers
                this.deactivating = true;

                //Reset ERror
                this.errors = {};

                //Setup Payload
                const payload = {
                    deactivate_all_contracts: this.deactivate_all_contracts,
                    deactivate_status_id: this.deactivate_status_id
                };

                //Send it
                this.$http.post('products/deactivate/'+this.id, payload)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.s('Product Deactivated' + (this.deactivate_all_contracts ? ' and All Contracts Deactivated' : ''));

                        //Return to main list?
                        this.$router.push('/products');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Deactivate Product');
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.deactivating = false;
                    });
            },
        },

        mounted() {
            //get the product?
            this.getProduct();
        }
    }
</script>
